module.exports = __webpack_public_path__ + "img/header.6a200d34.png";